import styled from 'styled-components';

export const Heading = styled.h1`
  font-size: 0;
`;
